var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("pulse-loader", {
        staticClass: "text-center",
        attrs: { loading: _vm.loading, color: _vm.$constants.LOADING_COLOR },
      }),
      _vm._v(" "),
      _vm.balance
        ? _c(
            "div",
            [
              _c("h5", { staticClass: "m-0" }, [
                _c("strong", [_vm._v(_vm._s(_vm.user.name))]),
              ]),
              _vm._v(" "),
              _vm._l(_vm.balance.currencies, function (amount, curr) {
                return _c("p", [
                  _vm._v(_vm._s(_vm.$AllCurrencies[curr]?.currency) + ": "),
                  _c("strong", [
                    _vm._v(_vm._s(amount.toLocaleString("ru-RU"))),
                  ]),
                ])
              }),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }